import { useContext } from 'react';

import { ThrottledLoader } from '@contexts/index';

export function useThrottledLoader<TResponse = any, TVariables = any>() {
  const ctx = useContext(
    ThrottledLoader.Context
  ) as ThrottledLoader.ContextValue<TResponse, TVariables>;
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!ctx) {
    throw new Error(
      'useThrottledLoader must be used inside ThrottledLoaderProvider'
    );
  }
  return ctx;
}
